module.exports = __webpack_public_path__ + "static/media/oberflex-sycomore-2560x1440.560d6618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-sycomore-2560x1440.jpg
// module id = 1057
// module chunks = 37